export const numberSpecialPattern = /^[0-9.]*$/;
export const phoneNoSpecialPattern = /^([0-9]+)+$/;
export const stringSpecialPattern = /^([a-zA-Z0-9]+[,.]?[ ]*?|[a-zA-Z0-9]+['-]?)+$/;
export const nameCapPattern = /^[A-Z][a-zA-Z.\s]*[a-zA-Z.]+$/;
export const agePattern = /^([^0]?[1-9]\d{0,3})$/;
export const localityPattern = /^([a-zA-Z0-9-/,]+[ -/,])*\w+.?$/;
// export const ENDPOINT = "https://test.autocloud.in/";
// export const ENDPOINT = "http://localhost:4004/";
export const ENDPOINT = "https://nandiyamaha.autocloud.in/";

export const panCardPattern = /^[A-Z0-9]{10}$/;
export const aadharCardPattern = /^[0-9]{12}$/;




